import React, { FC, useContext } from 'react'

import { FormattedMessage } from 'react-intl'

import { InteractiveButtonContext } from 'components/page/ForeignProfile/InteractiveButtons/CreateContext'
import {
  IconWrapper,
  Note,
} from 'components/page/ForeignProfile/InteractiveButtons/InteractiveButtons.styled'
import { WinkActiveSvg } from 'components/presentational/svg/WinkActiveSvg'
import { WinkDefaultSvg } from 'components/presentational/svg/WinkDefaultSvg'

interface WinkProps {
  isWinked: boolean
}

export const Wink: FC<WinkProps> = ({ isWinked }) => {
  const { backgroundColor } = useContext(InteractiveButtonContext)
  return (
    <>
      <IconWrapper $backgroundColor={backgroundColor}>
        <WinkIcon isWinked={isWinked} />
      </IconWrapper>
      <Note>
        <FormattedMessage
          id="foreign.profile.winked"
          defaultMessage="Подмигнуть"
        />
      </Note>
    </>
  )
}

export const WinkIcon: FC<WinkProps> = ({ isWinked }) => {
  const { id } = useContext(InteractiveButtonContext)

  if (isWinked) {
    return <WinkActiveSvg id={id} />
  }

  return <WinkDefaultSvg id={id} />
}
